import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, Checkbox, FormControlLabel} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {  addInternalLead } from "../api/customerapi";
import { airportlist } from "./date";
import GetRole from "./user";
import {preventDoubleClick} from "./preventDC.js"


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Leadentry = () => {

    const classes = useStyles();
    const currenturl = window.location.href;
    //const dispatch=useDispatch();
    const [leadData, setleadData] =useState({  });
     const { cuser, role, employeelist, destinationlist, loading } = GetRole();

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        console.log(leadData)
        
        if("lead_platform" in leadData && "lead_campaign" in leadData && "mobile_number_text" in leadData && "lead_destination" in leadData && "lead_name" in leadData && "lead_pax" in leadData){
          const mobilelength=leadData.mobile_number_text.length
    console.log(mobilelength)
    if(mobilelength>=10){
    const lasttenchar = leadData.mobile_number_text.substr(
      leadData.mobile_number_text.length - 10
    );

    const finalleaddata = {
      ...leadData,
      lead_owner: "Amit",
      work_complete: false,
      cust_create: true,
      mobile_number: lasttenchar,
      created_by:cuser,
      current_url:currenturl,
      createdAt:new Date(),
      assignedAt:new Date(),
    };

    console.log(finalleaddata)
    const leadaddResponse=await addInternalLead({finalleaddata:finalleaddata})
        if(leadaddResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          if(leadaddResponse.data.lead_id){
            alert("New lead added with lead id "+leadaddResponse.data.lead_id);
            window.location = ("/lead/"+leadaddResponse.data.lead_id);
          }else{
            alert("New lead not created. Lead or trip exists with this number. Check again")
          }
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      }else{
        alert("Phone number already exists")
      }
    }else{
      alert("All required fileds not entered")
    }
    }catch(err){
        console.log(err)
      }
        
    }
    
    const handlecampaignchange=(e)=>{
      if(e.target.value=="Others"){
          alert("Please mention the exact source of the lead to avoid future work")
      }
      setleadData({...leadData, lead_campaign: e.target.value})
    }

     const handleplatformchange=(e)=>{
      if(e.target.value=="Others"){
          alert("Please mention the exact source of the lead to avoid future work")
      }
      setleadData({...leadData, lead_platform: e.target.value})
    }
   

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add Lead</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel shrink id="Destination">Where do you want to go*</InputLabel>
                <Select native displayEmpty required className={classes.textField} labelId="Destination" value={leadData.lead_destination || ""} onChange={(e)=> setleadData({...leadData, lead_destination: e.target.value})}>
                 <option value="">--Please choose a destination--</option>
                    <optgroup label="Southeast Asia">
                      <option value="Bali">Bali</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Vietnam">Vietnam</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Laos">Laos</option>
                    </optgroup>
                    <optgroup label="West Asia">
                    <option value="Dubai">Dubai</option>
                    <option value="Abu Dhabi">Abu Dhabi</option>
                    <option value="Oman">Oman</option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    </optgroup>
                    <optgroup label="Islands">
                      <option value="Maldives">Maldives</option>
                      <option value="Mauritius">Mauritius</option>
                      <option value="Seychelles">Seychelles</option>
                    </optgroup>
                    <optgroup label="Central Asia">
                      <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Georgia">Georgia</option>
                    </optgroup>
                     <optgroup label="Far East">
                       <option value="Japan">Japan</option>
                     </optgroup>
                    <optgroup label="Europe">
                      <option value="Turkey">Turkey</option>
                    <option value="Europe">Europe</option>
                     <option value="Greece">Greece</option>
                    </optgroup>
                    <optgroup label="Domestic">
                    <option value="Andaman">Andaman</option>
                    <option value="Goa">Goa</option>
                    <option value="Golden Triangle">Delhi-Agra-Jaipur</option>
                    <option value="Gujarat">Gujarat</option>
                    <option value="Himachal">Himachal</option>
                    <option value="Kashmir">Kashmir</option>
                    <option value="Kerala">Kerala</option>
                    <option value="Ladakh">Ladakh</option>
                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                    <option value="Meghalaya">Meghalaya</option>
                    <option value="Odisha">Odisha</option>
                    <option value="Rajasthan">Rajasthan</option>
                    <option value="Sikkim-Darjeeling">Sikkim-Darjeeling</option>
                    <option value="Uttarakhand">Uttarakhand</option>
                     <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Others">Others</option>
                    </optgroup>
                </Select>
                </FormControl>
                <TextField variant="standard" required label="Date of travel (approx. date)" type="date" InputLabelProps={{ shrink: true }} value={leadData.lead_travel_date || ""} className={classes.textField} onChange={(e)=> setleadData({...leadData, lead_travel_date: e.target.value})}/>


            </FormGroup>


            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel shrink id="Flights">Flights required*</InputLabel>
                <Select displayEmpty required className={classes.textField} labelId="Flights" value={leadData.flight_required || ""} onChange={(e)=> setleadData({...leadData, flight_required: e.target.value})}>
                    <MenuItem value={"false"}>No</MenuItem>
                    <MenuItem value={"true"}>Yes</MenuItem>
                </Select>
                </FormControl>

                {leadData.flight_required=="true"?(
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel shrink id="Airport">Board flights from*</InputLabel>
                <Select displayEmpty required className={classes.textField} labelId="Airport" value={leadData.lead_source_airport || ""} onChange={(e)=> setleadData({...leadData, lead_source_airport: e.target.value})}>
                    {airportlist.map(data =>
                    <MenuItem value={data.airport}>{data.city}</MenuItem>)}
                </Select>
                </FormControl>
                ):(<div></div>)}

            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel shrink id="Adults">Adults (12 years or more)*</InputLabel>
                <Select displayEmpty required className={classes.textField} labelId="Adults" value={leadData.lead_pax || ""} onChange={(e)=> setleadData({...leadData, lead_pax: e.target.value})}>
                    <MenuItem value={"1"}>1</MenuItem>
                    <MenuItem value={"2"}>2</MenuItem>
                    <MenuItem value={"3"}>3</MenuItem>
                    <MenuItem value={"4"}>4</MenuItem>
                    <MenuItem value={"5"}>5</MenuItem>
                    <MenuItem value={"6"}>6</MenuItem>
                    <MenuItem value={"7"}>7</MenuItem>
                    <MenuItem value={"8"}>8</MenuItem>
                    <MenuItem value={"9"}>9</MenuItem>
                    <MenuItem value={"100"}>9+</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel shrink id="Children">Children (3-11 years)</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Children" value={leadData.lead_child || ""} onChange={(e)=> setleadData({...leadData, lead_child: e.target.value})}>
                    <MenuItem value={"0"}>0</MenuItem>
                    <MenuItem value={"1"}>1</MenuItem>
                    <MenuItem value={"2"}>2</MenuItem>
                    <MenuItem value={"3"}>3</MenuItem>
                    <MenuItem value={"4"}>4</MenuItem>
                    <MenuItem value={"5"}>5</MenuItem>
                    <MenuItem value={"100"}>5+</MenuItem>
                </Select>
                </FormControl>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <TextField variant="standard" required label="Name" InputLabelProps={{ shrink: true }} value={leadData.lead_name || ""} className={classes.textField} onChange={(e)=> setleadData({...leadData, lead_name: e.target.value})}/>
                <TextField variant="standard" required label="Email Id" type="email" InputLabelProps={{ shrink: true }} value={leadData.email_id || ""} className={classes.textField} onChange={(e)=> setleadData({...leadData, email_id: e.target.value})}/>
                <TextField variant="standard" required label="Mobile Number (whatsapp/call)" type="number" InputLabelProps={{ shrink: true }} inputProps={{ pattern: "\\d{10,12}", minLength: 10 }} value={leadData.mobile_number_text || ""} className={classes.textField} onChange={(e)=> setleadData({...leadData, mobile_number_text: e.target.value})}/>
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                <FormControlLabel
                  className={classes.textField}
                  control={<Checkbox checked={leadData.only_whatsapp || false} onChange={(e)=> setleadData({...leadData, only_whatsapp: e.target.checked})} name="only_whatsapp" value="WA"/>}
                  label="Contact on Whatsapp only"
                />
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel shrink id="Platform">Lead platform</InputLabel>
                <Select required className={classes.textField} labelId="Platform" value={leadData.lead_platform || ""} onChange={(e)=> handleplatformchange(e)}>
                    <MenuItem value={"Reference"}>Reference</MenuItem>
                    <MenuItem value={"Organic"}>Organic</MenuItem>
                    <MenuItem value={"Google Ads"}>Google Ads</MenuItem>
                    <MenuItem value={"Meta"}>Meta</MenuItem>
                    <MenuItem value={"Affiliate"}>Affiliate</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel shrink id="Campaign">Lead campaign</InputLabel>
                <Select required className={classes.textField} labelId="Campaign" value={leadData.lead_campaign || ""} onChange={(e)=> handlecampaignchange(e)}>
                    <MenuItem value={"Meta Chat"}>Meta Chat</MenuItem>
                    <MenuItem value={"Call on Website WA"}>Call on Website WA</MenuItem>
                    <MenuItem value={"Website WA"}>Website WA</MenuItem>
                    <MenuItem value={"Campaign WA"}>Campaign WA</MenuItem>
                    <MenuItem value={"Meta Ads WA"}>Meta Ads WA</MenuItem>
                    <MenuItem value={"Call"}>Call</MenuItem>
                    <MenuItem value={"Youtube"}>Youtube</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
                <TextField variant="standard" label="Referral Code" InputLabelProps={{ shrink: true }} value={leadData.ref_code || ""} className={classes.textField} onChange={(e)=> setleadData({...leadData, ref_code: e.target.value})}/>
                </FormGroup>

                <FormGroup className={classes.formgroup}>
                <TextField
                  variant="outlined"
                  label="Additional Details"
                  InputLabelProps={{ shrink: true }}
                  multiline
                  rows={4}
                  placeholder="starting city , duration, hotel category, age of children, any special request etc."
                  value={leadData.lead_notes || ""}
                  className={classes.textArea}
                  onChange={(e)=> setleadData({...leadData, lead_notes: e.target.value})}
                />
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                <FormControlLabel
                  className={classes.textField}
                  control={<Checkbox checked={leadData.consent === undefined ? true : leadData.consent} onChange={(e)=> setleadData({...leadData, consent: e.target.checked})} name="consent" value="Consent"/>}
                  label={<span>By submitting this form, I accept the <b>Terms and Conditions</b> mentioned <a href="/tnc" target="_blank" rel="noreferrer">here</a></span>}
                />
                </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" onClick={preventDoubleClick(handleSubmit)} className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default Leadentry;